import PropTypes from 'prop-types';
import CountUp from 'react-countup';

const normalizeNumber = (value) => {
	const num = typeof value === 'string' ? parseFloat(value) : value;
	return Number.isFinite(num) ? num : 0;
};

/** 业务统计数字滚动展示 */
const StatisticsCount = ({
	value,
	loading = false,
	mode = 'number',
	suffix = '',
	prefix = '',
	decimals = 0,
	duration = 1.35,
	className = '',
	preserveValue = true,
}) => {
	if (loading) {
		return <span className={className}>-</span>;
	}

	const end = normalizeNumber(value);

	if (mode === 'currency') {
		return (
			<span className={className}>
				<CountUp
					start={0}
					end={end}
					duration={duration}
					prefix='¥'
					separator=','
					decimals={2}
					decimal='.'
					preserveValue={preserveValue}
				/>
			</span>
		);
	}

	return (
		<span className={className}>
			<CountUp
				start={0}
				end={end}
				duration={duration}
				suffix={suffix}
				prefix={prefix}
				separator=','
				decimals={decimals}
				preserveValue={preserveValue}
			/>
		</span>
	);
};

StatisticsCount.propTypes = {
	value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	loading: PropTypes.bool,
	mode: PropTypes.oneOf(['number', 'currency']),
	suffix: PropTypes.string,
	prefix: PropTypes.string,
	decimals: PropTypes.number,
	duration: PropTypes.number,
	className: PropTypes.string,
	preserveValue: PropTypes.bool,
};

export default StatisticsCount;
